import { forwardRef } from 'react'
import type { InputHTMLAttributes, ReactNode } from 'react'
import { cx } from '../../cx'
import styles from './Checkbox.module.css'

export interface CheckboxProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label?: ReactNode
  /** Skrót na aria-invalid — ramka w kolorze --k1-danger przez CSS. */
  invalid?: boolean
}

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(function Checkbox(
  { label, invalid, className, ...rest },
  ref,
) {
  return (
    <label className={cx(styles.checkbox, className)}>
      <input
        ref={ref}
        type="checkbox"
        {...rest}
        aria-invalid={invalid ?? rest['aria-invalid']}
        className={styles.box}
      />
      {label !== undefined ? <span className={styles.text}>{label}</span> : null}
    </label>
  )
})
